import { useGetDocument } from "@src/api/queries/useGetDocument";

export function useDocumentPreview(documentId?: string, previewUrl?: string) {
  const { document } = useGetDocument(documentId, !previewUrl);
  return {
    document: document,
    previewUrl: document?.signedDownloadUrl,
  };
}
